export default {
  "telemetryTitle": "Telemetry Sources",
  "telemetrySubtitle": "Data freshness and availability",
  "liveStream": "Live stream",
  "snapshot": "Snapshot",
  "redisHistory": "Redis history",
  "vnstat": "vnStat",
  "noDataYet": "No data yet",
  "unknown": "Unknown",
  "loading": "Loading",
  "issue": "Issue",
  "noData": "No data",
  "healthy": "Healthy",
  "warning": "Warning",
  "critical": "Critical",
  "notConfigured": "Not configured",
  "needsReview": "Needs review",
  "detailsTitle": "Health Details",
  "detailsSubtitle": "Jump to health card panels",
  "networkDetails": "Network details",
  "databaseDetails": "Database details",
  "redisDetails": "Redis details",
  "cpuMemoryDetails": "CPU & Memory details",
  "health": "Health",
  "systemHealth": "System Health",
  "unavailable": "N/A",
  "scoreAria": "System health score: {{score}} out of {{maximum}}. Status: {{status}}",
  "scoreLoading": "Loading system health score",
  "scoreUnavailable": "System health score unavailable",
  "cpu": "CPU",
  "memory": "Memory",
  "disk": "Disk",
  "breakdownAria": "{{metric}} health: {{score}} out of {{maximum}}. Status: {{status}}"
} as const;
